module.exports = __webpack_public_path__ + "static/media/2.Engine Operated Sprayer.69e7d2bd.jpg";